/**
 * The browser half of the screen registry: each screen's component, lazy-loaded so its code downloads only when it's
 * opened. What a screen is called, its icon and whether it's a draft live in src/shared/screen-meta.ts; its data in
 * src/server/routes.ts. `bun run new:screen` adds a line to each.
 */
import { lazy, type ComponentType, type LazyExoticComponent } from 'react'
import { screenMeta, screenPaths, type ScreenMetaEntry, type ScreenPath } from './shared/screen-meta'

const components: Record<ScreenPath, LazyExoticComponent<ComponentType>> = {
  '/today': lazy(() => import('./screens/today/Screen')),
  '/board': lazy(() => import('./screens/board/Screen')),
  // new screens go above this line (bun run new:screen)
}

export interface Screen extends ScreenMetaEntry {
  path: ScreenPath
  component: LazyExoticComponent<ComponentType>
}

/** Every screen, in nav order. */
export const screens: Screen[] = screenPaths.map((path) => ({ path, ...screenMeta[path], component: components[path] }))
